export default __webpack_public_path__ + "static/image5-9999798b7f93d24f97249984cf956597.jpg";